<template>
<div class="section" v-if="experiences && experiences.length > 0">
  <heading>{{$t('profile.experience')}}</heading>
  <div class="cards">
    <experience-card v-for="experience in experiences"
    :key="experience.id"
    :experience="experience"
    class="experience-card" />
  </div>
</div>
</template>

<script>
import ExperienceCard from '@/components/profile/experience-row-card'
import Heading from '@/components/general/heading'
import { mapState, mapActions } from 'vuex'

export default {
  components: { ExperienceCard, Heading },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    ...mapActions('jobseekers', [
      'getExperiences'
    ])
  },
  computed: {
    ...mapState('jobseekers', {
      experiences: 'currentExperiences'
    })
  },
  async mounted () {
    await this.getExperiences(this.id)
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/jobseekers/experience-section.vue